//
// Функция сравнения категорий для сортировки
//
export const compare = (a, b, lang) => {
    if(typeof a.priority !== 'number' || typeof b.priority !== 'number') {
        return a.name[lang].localeCompare(b.name[lang]);
    }
    if(a.priority === b.priority) {
        return a.name[lang].localeCompare(b.name[lang]);
    }
    return a.priority - b.priority;
};
